/**
 * An object containing properties for notification events
 */
var NotificationEvent = /** @class */ (function () {
    function NotificationEvent() {
    }
    return NotificationEvent;
}());
export { NotificationEvent };
//# sourceMappingURL=notification-event.js.map